
import React from 'react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Professores Especializados',
      description: 'Instrutores com mais de 15 anos de experiência em tributação e reforma fiscal',
      highlight: 'Expertise comprovada'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Conteúdo Atualizado',
      description: 'Material baseado nas últimas atualizações da legislação tributária 2024/2025. Lei complementar nº 214 2025. Totalizando 544 artigos decidido em 3 livros (I, II e III). Temas dos livros: Livro I: IBS e CBS / Livro II: Imposto Seletivo / Livro III: disposições especiais, transição, compensações etc.',
      highlight: 'Sempre atual'
    },
    {
      icon: 'ri-team-line',
      title: 'Networking Qualificado',
      description: 'Conecte-se com outros profissionais da área tributária e expanda sua rede',
      highlight: 'Conexões valiosas'
    },
    {
      icon: 'ri-award-line',
      title: 'Certificado Reconhecido',
      description: 'Certificado de participação válido para pontuação em órgãos de classe',
      highlight: 'Reconhecimento oficial'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Casos Práticos',
      description: 'Simulações reais de situações tributárias que você enfrentará no dia a dia',
      highlight: 'Aplicação imediata'
    },
    {
      icon: 'ri-group-2-line',
      title: 'Turmas Reduzidas',
      description: '1. Reunião de Alinhamento Diário – "Daily Stand-Up" ou "Daily Huddle". Objetivo: participantes para garantir atenção personalizada',
      highlight: 'Aprendizado focado'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Por que escolher nossos ecossistema?
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Resultados comprovados e metodologia exclusiva
            </p>
            <div className="bg-white border-2 border-orange-200 rounded-lg p-6 max-w-4xl mx-auto shadow-sm">
              <p className="text-lg text-gray-900 font-medium">
                "21 bilhões: o número importa, mas nossa experiência de mais de 20 anos e 11 empresas integradas garante que seja possível."
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <div className="bg-blue-50 border-2 border-blue-100 rounded-xl p-6 text-center hover:shadow-xl hover:border-blue-200 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Conhecimento Prático</h3>
              <p className="text-gray-700">Aplicação imediata no seu trabalho</p>
            </div>
            
            <div className="bg-green-50 border-2 border-green-100 rounded-xl p-6 text-center hover:shadow-xl hover:border-green-200 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Networking</h3>
              <p className="text-gray-700">Conecte-se com profissionais da área</p>
            </div>
            
            <div className="bg-purple-50 border-2 border-purple-100 rounded-xl p-6 text-center hover:shadow-xl hover:border-purple-200 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Certificação</h3>
              <p className="text-gray-700">Reconhecimento profissional</p>
            </div>
            
            <div className="bg-orange-50 border-2 border-orange-100 rounded-xl p-6 text-center hover:shadow-xl hover:border-orange-200 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Carreira</h3>
              <p className="text-gray-700">Acelere seu crescimento profissional</p>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-blue-50 to-orange-50 border-2 border-orange-200 rounded-2xl p-8 text-center">
            <div className="max-w-3xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                🚀 Oportunidade Única: Mercado de <span className="text-orange-500">R$ 17 Trilhões</span> em Consultoria Tributária
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                A Reforma Tributária criará a maior demanda por consultoria especializada da história do Brasil. 
                Seja um dos primeiros a dominar as novas regras e capture sua fatia deste mercado bilionário.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 border-2 border-gray-100 text-center shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-orange-500 rounded-xl flex items-center justify-center">
                <i className="ri-trophy-line text-white text-2xl"></i>
              </div>
            </div>

            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Equipe de Expansão 
            </h3>

            <p className="text-gray-700 text-lg mb-6 max-w-2xl mx-auto">
              Junte-se a mais de 2.000 profissionais que já transformaram suas carreiras 
              com nossa metodologia exclusiva de consultoria tributária
            </p>

            <div className="flex items-center justify-center space-x-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-500">98%</div>
                <div className="text-gray-900 text-sm font-semibold">Satisfação</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-500">2.000+</div>
                <div className="text-gray-900 text-sm">Parceiros Business Tax</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-500">15+</div>
                <div className="text-gray-900 text-sm">Anos</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
